import React from "react";
import OptionTitle from "../components/resultItems/OptionTitle";
import PassFailCriteria from "../components/resultItems/PassFailCriteria";
import CondensedCaveatAvatars from "../components/resultItems/CondensedCaveatAvatars";
import OptionInlineCategory from "../components/resultItems/OptionInlineCategory";
import Notes from "../components/resultItems/Notes";
import ToggleHideOption from "../components/resultItems/ToggleHideOption";
import ColorCodedCriteriaAvatars from "./resultItems/ColorCodedCriteriaAvatars";
import Star from "./resultItems/Star";
import AssessmentTier from "./resultItems/AssessmentTier";
import {isEqual} from "lodash";

export default class CaveatVisualizationRow extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.option.id !== nextProps.option.id ||
      this.props.hidden !== nextProps.hidden ||
      this.props.note !== nextProps.note ||
      this.props.readOnly !== nextProps.readOnly ||
      this.props.categoryProp !== nextProps.categoryProp ||
      this.props.enabledActions.hide !== nextProps.enabledActions.hide ||
      this.props.enabledActions.star !== nextProps.enabledActions.star ||
      this.props.enabledActions.sort !== nextProps.enabledActions.sort ||
      this.props.starred !== nextProps.starred ||
      !(isEqual(this.props.option, nextProps.option))
    );
  }

  render() {
    let {
      option,
      note,
      onToggleOptionHidden,
      onNoteClick,
      displayCriteria,
      onClick,
      hidden,
      readOnly,
      maxCaveats,
      colorCodedCriteria,
      categoryProp,
      enabledActions,
      starred,
      onStarClick
    } = this.props;
    onClick = onClick.bind(null, option);
    return (
            <div
                key={"rrow-" + option.id}
                className="resultsRow"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  position: "relative",
                  paddingTop: 2,
                  paddingBottom: 2,
                  opacity: hidden ? 0.5 : 1,
                  backgroundColor: hidden ? "#efefef" : null
                }}
              >
                { enabledActions.hide && !starred && <ToggleHideOption
                  hidden={hidden}
                  onClick={onToggleOptionHidden.bind(null, option)}
                  readOnly={readOnly}
                /> }
                {!enabledActions.star && starred && <Star starred={starred} style={{cursor: "auto"}}/>}
                { enabledActions.star && <Star starred={starred} readOnly={readOnly} onClick={onStarClick.bind(null, option)} /> }

                <Notes readOnly={readOnly} note={note} onClick={onNoteClick} />
                {displayCriteria ? (
                  !colorCodedCriteria ? (
                    <PassFailCriteria
                      eliminatedBy={option.eliminatedBy || []}
                      metCriteria={option.metCriteria || []}
                      onClick={onClick}
                    />
                  ) : (
                    <ColorCodedCriteriaAvatars
                      eliminated={option.eliminated}
                      eliminatedBy={option.eliminatedBy || []}
                      metCriteria={option.metCriteria || []}
                      onClick={onClick}
                    />
                  )
                ) : null}
                <CondensedCaveatAvatars
                  maxCaveats={maxCaveats}
                  caveats={option.caveats}
                  onClick={onClick}
                />
                <OptionInlineCategory
                  title={/input/i.test(categoryProp) ? (option.inputCategory ? option.inputCategory.title : 'null') : option.category.title}
                  onClick={onClick}
                />
                {
                  this.props.section === "assessment" && <AssessmentTier
                    assessmentTier={option.assessmentTier}
                    onClick={onClick}
                  />
                }
                <OptionTitle title={option.title} onClick={onClick} />
              </div>
    );
  }
}
